"use strict";
var __webpack_modules__ = {
    "./icons/AiSearch.svg?react": function(module) {
        module.exports = import("./icons/AiSearch.cjs").then(function(module) {
            return module;
        });
    },
    "./icons/Discount.svg?react": function(module) {
        module.exports = import("./icons/Discount.cjs").then(function(module) {
            return module;
        });
    },
    "./icons/DiscountFill.svg?react": function(module) {
        module.exports = import("./icons/DiscountFill.cjs").then(function(module) {
            return module;
        });
    },
    "./icons/Disney.svg?react": function(module) {
        module.exports = import("./icons/Disney.cjs").then(function(module) {
            return module;
        });
    },
    "./icons/Hotel.svg?react": function(module) {
        module.exports = import("./icons/Hotel.cjs").then(function(module) {
            return module;
        });
    },
    "./icons/Penny.svg?react": function(module) {
        module.exports = import("./icons/Penny.cjs").then(function(module) {
            return module;
        });
    },
    "./icons/PricelineP.svg?react": function(module) {
        module.exports = import("./icons/PricelineP.cjs").then(function(module) {
            return module;
        });
    },
    "./icons/Sparkle.svg?react": function(module) {
        module.exports = import("./icons/Sparkle.cjs").then(function(module) {
            return module;
        });
    },
    "./icons/Waveform.svg?react": function(module) {
        module.exports = import("./icons/Waveform.cjs").then(function(module) {
            return module;
        });
    }
};
var __webpack_module_cache__ = {};
function __webpack_require__(moduleId) {
    var cachedModule = __webpack_module_cache__[moduleId];
    if (void 0 !== cachedModule) return cachedModule.exports;
    var module = __webpack_module_cache__[moduleId] = {
        exports: {}
    };
    __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    return module.exports;
}
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
(()=>{
    __webpack_require__.r(__webpack_exports__);
    __webpack_require__.d(__webpack_exports__, {
        iconRegistry: ()=>iconRegistry
    });
    const iconRegistry = {
        Waveform: ()=>Promise.resolve().then(__webpack_require__.bind(__webpack_require__, "./icons/Waveform.svg?react")),
        Sparkle: ()=>Promise.resolve().then(__webpack_require__.bind(__webpack_require__, "./icons/Sparkle.svg?react")),
        PricelineP: ()=>Promise.resolve().then(__webpack_require__.bind(__webpack_require__, "./icons/PricelineP.svg?react")),
        Penny: ()=>Promise.resolve().then(__webpack_require__.bind(__webpack_require__, "./icons/Penny.svg?react")),
        Hotel: ()=>Promise.resolve().then(__webpack_require__.bind(__webpack_require__, "./icons/Hotel.svg?react")),
        Disney: ()=>Promise.resolve().then(__webpack_require__.bind(__webpack_require__, "./icons/Disney.svg?react")),
        DiscountFill: ()=>Promise.resolve().then(__webpack_require__.bind(__webpack_require__, "./icons/DiscountFill.svg?react")),
        Discount: ()=>Promise.resolve().then(__webpack_require__.bind(__webpack_require__, "./icons/Discount.svg?react")),
        AiSearch: ()=>Promise.resolve().then(__webpack_require__.bind(__webpack_require__, "./icons/AiSearch.svg?react"))
    };
})();
exports.iconRegistry = __webpack_exports__.iconRegistry;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "iconRegistry"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
